import useMediaQuery from "../hooks/useMediaQuery";
import { motion } from "framer-motion";
import AnchorLink from "react-anchor-link-smooth-scroll";
import SocialMediaIcons from "../components/SocialMediaIcons";

const Landing = ({setSelectedPage}) => {
const isAboveMediumScreens = useMediaQuery('(min-width: 1060px)');

return (
    <section id="home" className="md:flex md:justify-between md:items-center md:h-full gap-16 py-10">

        {/*Images*/}
        <div className="md:order-2 flex justify-center basis-3/5 z-10 mt-16 md:mt-32">
        {isAboveMediumScreens ?(
            <div
            className="relative z-0 ml-20 before:absolute before:-top-36 before:-left-36
            before: rounded-t-[400px] before: rounded-b-2xl before: w-72 before:max-w-[400px] 
            before: h-full before: border-0 before: border-blue before:z-[-1] before: bg-gradient-to-r from-blue to-red"
            >
                
              
                    <img
                    alt="profile"
                    className="hover:filter hover:saturate-150 hover:brightness-110
                    transition duration-500 z-10 w-80 h-full max-w-[300px] md:max-w-[600px]"
                    src="assets/Vicky.png"
                     />
              
                
            </div>

        ):(
                <img
                    alt="profile"
                    className="hover:filter hover:saturate-150 hover:brightness-110
                    transition duration-500 z-10 w-80 h-full max-w-[300px] md:max-w-[600px]"
                    src="assets/Vicky.png"
                /> 
        )}
        </div>
        {/* Main Section  */}
            <div
            className="z-30 basis-2/5 mt-12 md:mt-32 ">

                {/* Headings */}
                <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.5}}
                transition={{duration: 0.5}}
                variants={{
                    hidden: {opacity: 0, x: -50},
                    visible: {opacity: 1, x: 0}
                }}
                >
                    <p
                    className="text-6xl font-acorn z-10 text-center md:text-start"
                    >
                        Hi, I'm{"  "}
                        <span 
                        className="xs:relative xs:text-deep-blue xs:font-semibold z-20 xs:before:content-brush
                        before:absolute before:-left-[25px] before:-top-[90px] before:z-[-1]">Vikram</span>

                        
                    </p>

                    <p
                    className="mt-10 mb-7 text-sm text-center md:text-start"
                    >
                    A Master of Science candidate in Computer and Information Science at the University of Michigan-Dearborn, with a strong penchant for prototyping, web development and machine learning.
                    </p>
                </motion.div>
                    
                    {/* more animation */}
                    <motion.div
                    className="flex mt-5 justify-center md:justify-start"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true, amount: 0.5}}
                    transition={{delay:0.2, duration: 0.5}}
                    variants={{
                        hidden: {opacity: 0, x: -50},
                        visible: {opacity: 1, x: 0}
                    }}
                    >
                        <AnchorLink
                        className="bg-gradient-rainblue text-deep-blue px-7 py-3 rounded-sm text-base font-semibold hover:bg-blue 
                        hover:text-white transition duration-500"
                        href="#contact"
                        onClick={() => setSelectedPage("contact")} 
                        
                        >
                            Contact Me
                        </AnchorLink>

                        <AnchorLink
                        className="rounded-r-sm bg-gradient-rainblue py-0.5 pr-0.5"
                         onClick={() => setSelectedPage("contact")}
                         href="#contact"
                        >
                            <div
                            className="bg-deep-blue text-white px-10 rounded-sm 
                            text-base font-semibold hover:text-red transition-500 w-full h-full
                            flex items-center justify-center"
                            >
                            Discuss your Ideas!
                            </div>
                           
                        </AnchorLink>
                    </motion.div>

                    {/* social media buttons */}
                    <motion.div
                    className="flex mt-5 justify-center md:justify-start"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true, amount: 0.5}}
                    transition={{delay:0.4, duration: 0.5}}
                    variants={{
                        hidden: {opacity: 0, x: -50},
                        visible: {opacity: 1, x: 0}
                    }}
                    >
                        <SocialMediaIcons />

                    </motion.div>
            </div>

    </section>
)

}
export default Landing;